const Phone = 640;
const Tablet = 767;
const Desktop = 1024;

export default {
  Phone,
  Tablet,
  Desktop,
};
